import { Action } from '../../../../../shared/xs/actions';

export class GetEnterpriseAction implements Action {
  static readonly type = '[Company] Get Enterprise';
}

export interface GetEnterpriseActionPayload {
  name?: string;
}
